/**
 * Lightbox Gallery Functionality
 * 
 * Using image parents a lot because of lazy loading
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <john@chatmandesign.com>
 * @link      http://chatmandesign.com
 */


(function($) {
    let lightboxClass = 'img-lightbox';
    let contentImgs = '.' + lightboxClass;
    let imageContentWrap = '.wp-block-cd-image-copy-wrap';
    let lightboxEnter = contentImgs + '__modal.enter';
    let lightboxClose = contentImgs + '__modal .close';
    let lightboxCloseMobile = contentImgs + '__modal .close.mobile';

    function setupImgModals() {
        let lightIndex = 0;

        $(`${contentImgs}, ${imageContentWrap}`).each(function() {
            let currTag     = $(this).get(0).tagName;
            let singleImage = currTag === 'IMG';
            let properImgs  = [];
    
            if( singleImage){ 
                $(this).attr('light-index', lightIndex);
                $(this).on('click', imgOpenLightbox);
                properImgs.push({
                    'src': $(this).attr('src'),
                    'alt': $(this).attr('alt'),
                    'index': lightIndex,
                });
                lightIndex++;
            } else {
                $(this).find('img').each(function() {
                    $(this).attr('light-index', lightIndex);
                    $(this).on('click', imgOpenLightbox);
                    let imgSrc = $(this).attr('src');
                    let imgAlt = $(this).attr('alt');
                    properImgs.push({
                        'src': imgSrc,
                        'alt': imgAlt,
                        'index': lightIndex,
                    });
                    lightIndex++;
                });
            }

            //properImgs.forEach(appendLightboxModals);
            properImgs.forEach(function(item) {
                $(this).attr('light-index', lightIndex);
                appendLightboxModals(item);
                lightIndex++;
            });   

        });
    }

    function appendLightboxModals(item) {
        let initialTransform = 'translate(-50%, -50%)';
        let lightboxMarkup = $(`
                <div class="img-lightbox__modal" light-index="${item.index}">
                    <button class="close mobile">&times;</button>
                    <div class="container">
                        <img src="${item.src}" alt="${item.alt}" />
                        <button class="close">&times;</button>
                    </div>
                </div>
        `);
        lightboxMarkup.appendTo('body');
    }

    function imgOpenLightbox() {
        let lightIndex = $(this).attr('light-index');

        if( $('.img-lightbox__modal[light-index="' + lightIndex + '"]').length ) {
            let lightModal = $('.img-lightbox__modal[light-index="' + lightIndex + '"]');
            imgLightboxScale(lightModal);
            lightModal.css('display', 'block');
            setTimeout(function() {
                lightModal.addClass('enter');
            }, 100);
        }
    }

    // Really just need a nice set of image utilities for this nonsense
    function imgLightboxScale(elem) {
        let containerTransform = 'translate(-50%, -50%)';
        let image = elem.find('img');
        let container = elem.find('.container');
        
        let imageWidth = image.get(0).naturalWidth;
        let imageHeight = image.get(0).naturalHeight;

        // Don't want to count padding
        let totalWidth = elem.width();
        let totalHeight = elem.height();

        
        let imgRatio = imageWidth / imageHeight;
        let totalRatio = totalWidth / totalHeight;

        let test = (imgRatio > totalRatio); // for contain

        let targetWidth = 0;
        let targetHeight = 0;

        if( test ) {
            targetWidth = totalWidth;
            targetHeight = targetWidth / imgRatio;
        } else {
            targetHeight = totalHeight;
            targetWidth = targetHeight * imgRatio;
        }

        // scaleX will equal scaleY
        let scaleX = targetWidth / imageWidth;

        if( totalWidth > imageWidth && totalHeight > imageHeight ) {
            scaleX = 1;
        }

        containerTransform += ` scale(${scaleX})`;

        container.css('transform', containerTransform);
    }

    function lightboxModalFocus(event) {
        if( !$(lightboxEnter).length ) return;
        let isMobile = $(window).width() < 640;
        event.preventDefault();
        if( isMobile ) {
            $(lightboxCloseMobile).focus();
        } else {
            $(lightboxClose).focus();
        }
    }
    
    //! – DOM READY
    $(function() {
        //initBlockGallery();

        $('body').arrive(lightboxEnter, {fireOnAttributesModification: true}, function() {
            $(this).on('click', function(event) {
                event.preventDefault();
                $(this).find('.container').removeAttr('style'); // clear any styling 
                $(this).addClass('exit');
                let $this = $(this);
                setTimeout(function() {
                    $this.removeClass('enter exit');
                    $this.css('display', 'none');
                }, 700);
            });
        });

    }); // jQuery document ready 

    $(window).load(function() {
        setupImgModals();
    });

    // On Window Resize
    $( window ).resize(function() {
        if( $(lightboxEnter).length ) {
            imgLightboxScale($(lightboxEnter));
        }
    });

    $('body').keyup(function(event){
        let code = event.keyCode || event.which;
        if( code == '9' ) {
            lightboxModalFocus(event);
        }
    });

})(jQuery);